export default __webpack_public_path__ + "static/media/sofia.1bfdca2c.png";